import styled from 'styled-components';

export const BoxOptions = styled.div`
  position: relative;
  width: 70%;
  margin-left: 30px;

  input {
    width: 100%;
    padding: 5px;
    font-size: 16px;
    font-weight: 100;
    font-family: ${({ theme }) => theme.font.fontFamily.regular};
    color: ${({ theme }) => theme.font.color.primary};
    padding: 9.5px;
  }
`;

export const BoxTextOptions = styled.div`
  border: 1px solid #ccc;
  max-height: 350px;
  margin-top: 10px;
  overflow-y: auto;
  position: absolute;
  width: 100%;
  background: #fff;
  z-index: 10;
  border-radius: 4px;
`;

export const TextOptions = styled.div`
  padding: 8px;
  font-size: 16px;
  font-weight: 100;
  font-family: ${({ theme }) => theme.font.fontFamily.regular};
  color: ${({ theme }) => theme.font.color.primary};

  &&:hover {
    background: #ebe8e8;
    cursor: pointer;
  }
`;

export const NotFoundMessage = styled.div`
  padding: 8px;
  font-size: 16px;
  font-weight: 100;
  font-family: ${({ theme }) => theme.font.fontFamily.regular};
`;
